import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import UnresolvedTickets from "./pages/UnresolvedTickets";
import ResolvedTickets from "./pages/ResolvedTickets";
import Users from "./pages/Users";
import ApprovalWorkflow from "./pages/ApprovalWorkflow";
import Header from "./components/Header";
import TicketDetails from "./pages/TicketDetails";

const PrivateRoute = ({ children }) => {
  const isAuthenticated = localStorage.getItem("isAuthenticated");
  return isAuthenticated ? children : <Navigate to="/" />;
};

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <Header />
              <Dashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/unresolved-tickets"
          element={
            <PrivateRoute>
              <Header />
              <UnresolvedTickets />
            </PrivateRoute>
          }
        />
        <Route
          path="/resolved-tickets"
          element={
            <PrivateRoute>
              <Header />
              <ResolvedTickets />
            </PrivateRoute>
          }
        />
        <Route
          path="/users"
          element={
            <PrivateRoute>
              <Header />
              <Users />
            </PrivateRoute>
          }
        />
        <Route
          path="/approval-workflow"
          element={
            <PrivateRoute>
              <Header />
              <ApprovalWorkflow />
            </PrivateRoute>
          }
        />
        <Route
          path="/ticket/:id"
          element={
            <PrivateRoute>
              <Header />
              <TicketDetails />
            </PrivateRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
